import { createSlice, PayloadAction } from '@reduxjs/toolkit';
import { NameSpace } from '../../const';
import { Directions } from '../../types/state';
import { FetchDirectionsParams } from '../../types/request';

const initialState: Directions = {
  data: [],
  fetchingStatusDirections: false,
  error: null
};

export const directions = createSlice({
  name: NameSpace.Directions,
  initialState,
  reducers: {
    fetchDirectionsRequest: (state, payload: PayloadAction<FetchDirectionsParams>) => {
      state.fetchingStatusDirections = true;
      state.error = null;
    },
    fetchDirectionsSuccess: (state, action) => {
      state.fetchingStatusDirections = false;
      state.data = action.payload;
    },
    fetchDirectionsFailure: (state, action) => {
      state.fetchingStatusDirections = false;
      state.error = action.payload;
    },
  },
});

export const { fetchDirectionsRequest, fetchDirectionsSuccess, fetchDirectionsFailure } = directions.actions;
